import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { isArray, isNumber, isObject } from 'lodash';
import React from 'react';

import useStyles from './KeyValueResponsive.styles';
import type { KeyValueResponsiveProps } from './KeyValueResponsive.types';

const KeyValueResponsive = (props: KeyValueResponsiveProps) => {
  const { items, resizable } = props;
  const { classes } = useStyles({ resizable });
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Box
      className={`${classes.keyValueResponsiveContainer} kvResponsiveContainer`}
    >
      {items?.map((item) => {
        if (
          (isObject(item.value) || isArray(item.value)) &&
          !React.isValidElement(item.value)
        ) {
          return null;
        }
        return (
          <Box
            key={item.label}
            className={`${classes.keyValueResponsive} kvResponsive ${item.className || ''}`}
            sx={{ pr: '5rem' }}
          >
            <Typography
              className={`${classes.keyValueResponsiveLabel} kvLabel`}
            >
              {item.label}
            </Typography>
            <Typography
              className={`${classes.keyValueResponsiveValue} kvValue`}
              component="div"
            >
              {/* Display value unless there is a chip, then display the chip */}
              {isNumber(item.value) ? item.value : item.value || '--'}
              {item.icon && React.isValidElement(item.icon) && (
                <Box component="span" sx={{ ml: 1 }}>
                  {item.icon}
                </Box>
              )}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default KeyValueResponsive;
